export enum UserType {
    GUEST = 'Guest',
    PUBLIC = 'Public',
    NORMAL = 'Normal',
}